// src/components/Control/Operator/DesktopLayout.tsx
// Desktop / ноутбук / планшет / телефон в landscape: всё в одном экране без
// вертикальной прокрутки. Шапка → строка управления → карта + камера → статус.
// Раскладки «Карта» (75/25), «Поровну» (50/50), «Камера» (30/70): оба блока видны всегда.
// Pi без шасси: ни управления, ни карты — камера на всю ширину.
import React from 'react';
import { useHasChassis, useRobot, useUi } from '../robot/RobotContext';
import Header from './Header';
import ControlBar from './ControlBar';
import StatusStrip from './StatusStrip';
import { CameraPane } from './Camera';
import NannyScreen from './NannyScreen';
import Settings from './Settings';
import MapViewer from '../ControlPanel/MapViewer';

const DesktopLayout: React.FC = () => {
  const { session, robotId } = useRobot();
  const screen = useUi(u => u.screen);
  const layout = useUi(u => u.layout);
  const chassis = useHasChassis();
  const operator = screen === 'map' || screen === 'camera';

  return (
    <div className="op-app desktop">
      <Header variant="desktop" />
      {operator && chassis && <ControlBar showLayout />}
      {/* Карта остаётся смонтированной на других экранах — чтобы не терять след */}
      <main className={`op-main layout-${chassis ? layout : 'station'}`} hidden={!operator}>
        {chassis && (
          <section className="op-map-pane" aria-label="Карта">
            <MapViewer zenohSession={session} robotId={robotId} />
          </section>
        )}
        {operator && <CameraPane />}
      </main>
      {screen === 'nanny' && <NannyScreen variant="desktop" />}
      {screen === 'settings' && <Settings variant="desktop" />}
      <StatusStrip />
    </div>
  );
};

export default DesktopLayout;
